<template>
  <LoginModalComponent />

  <div class="container-fluid bg-dark bg-gradient">
    <div class="row">
      <div class="col-2 content pt-3 overflow-auto">
        <!-- Navbar -->
        <NavbarComponent />
      </div>
      <div class="col-4 content overflow-auto pt-3">
        <!-- Search Results component-->
        <SearchResultsComponent />
      </div>
      <div class="col-4 content overflow-auto pt-3">
        <!-- Queue -->
        <QueueComponent />
      </div>

      <div class="col-2 content overflow-auto pt-3">
        <!--        Login-->
        <div class="container-fluid d-grid">
          <Spotify />
        </div>
      </div>
    </div>
    <div class="row">
      <!--      Player-->
      <div class="col-12 player">player</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import Spotify from "../components/Spotify.vue";
import SearchResultsComponent from "../components/SearchResultsComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";
import QueueComponent from "@/components/QueueComponent.vue";
import LoginModalComponent from "@/components/LoginModalComponent.vue";

@Options({
  name: "HomePage",
  components: {
    Spotify,
    SearchResultsComponent,
    NavbarComponent,
    QueueComponent,
    LoginModalComponent,
  },
})
export default class App extends Vue {}
</script>

<style scoped>
.content {
  height: 90vh;
  border-style: solid;
}

.player {
  height: 10vh;
  border-style: solid;
}
</style>
